import React from "react";
import { Nav } from "./sections/Nav";
import { Hero } from "./sections/Hero";
import { Alltag } from "./sections/Alltag";
import { Ablauf } from "./sections/Ablauf";
import { Vertrauen } from "./sections/Vertrauen";
import { Regelwerk } from "./sections/Regelwerk";
import { Assurances } from "./sections/Assurances";
import { Faq } from "./sections/Faq";
import { CtaBand } from "./sections/CtaBand";
import { Footer } from "./sections/Footer";
import { DEMO_URL } from "./lib/demo-entry";

export default function App() {
  // #1856: the demo is a static page on this host that starts by itself; no registration.
  const openDemo = React.useCallback(() => {
    window.location.assign(DEMO_URL);
  }, []);

  return (
    <>
      <Nav onOpenDemo={openDemo} />
      <Hero onOpenDemo={openDemo} />
      <Alltag />
      <Ablauf />
      <Vertrauen />
      <Regelwerk />
      <Assurances />
      <Faq />
      <CtaBand onOpenDemo={openDemo} />
      <Footer />
    </>
  );
}
